import React, { useContext as useContextCore } from 'react'
import type { AdjustmentContext, AdjustmentProviderProps } from '@ztechapps/webui.contract'

const context = React.createContext<AdjustmentContext>({} as AdjustmentContext)
const CoreProvider = context.Provider

export const AdjustmentProvider = ({ children, ...props }: AdjustmentProviderProps) => {
  return <CoreProvider value={{ ...props }}>{children}</CoreProvider>
}

export const useAdjustmentContext = () => useContextCore(context)
